export const LOADING_PRODUCTS = "LOADING_PRODUCTS";
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";
export const ADD_PRODUCTS = "ADD_PRODUCTS";
export const ADD_PRODUCT_INFO = "ADD_PRODUCT_INFO";
export const SELECT_SIZE = "SELECT_SIZE";